import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';

export enum FormulaAction {
	Delete = 'delete',
	Duplicate = 'duplicate',
}

export interface IFormulaActionModalData {
	formulaId: number | Array<number>;
	element: string;
	action: FormulaAction;
}
@Component({
	selector: 'app-formula-action-popup',
	templateUrl: './formula-action-popup.component.html',
	styleUrls: ['./formula-action-popup.component.scss'],
})
export class FormulaActionPopupComponent<
	T extends IFormulaActionModalData
> extends DcBaseComponent {
	protected readonly DcIcons = DcIcons;
	protected readonly FormulaAction = FormulaAction;
	public readonly Icons = DcIcons;
	public vo$: Observable<{
		element: string;
		formulaId: number | Array<number>;
		isMultipleElement: boolean;
		action: FormulaAction;
	}>;
	public confirmDeletion = false;

	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'formula-action';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.formulaId) &&
				this.modalData.element === '',
			formulaId: this.modalData.formulaId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
